import { Dispatch, SetStateAction } from 'react';

import { NavConfig, NavListPropsWithItemName, NavListPropsWithTab } from 'components/NavMenu/type';
import { OpenedTabsState, PathState } from 'types/menu';

export const setCurrentPath = (
  path: string,
  config: NavConfig[],
  openedTabs: OpenedTabsState,
  setPath: Dispatch<SetStateAction<PathState>>,
  setTabs: Dispatch<SetStateAction<OpenedTabsState>>
) => {
  const tabs = Object.values(config);

  const tab = tabs.find((tab) => tab?.item?.path === path);

  if (tab) {
    setPath({ tab: tab.subheader, item: null, subitem: null });

    setTabs({
      ...openedTabs,
      [tab.subheader]: true,
    });

    return;
  }

  const items = tabs.reduce((acc, tab) => {
    if (tab.items) {
      const tabItems = tab.items.map((item) => ({ ...item, tab: tab.subheader }));

      return [...acc, ...tabItems];
    }

    return acc;
  }, [] as NavListPropsWithTab[]);

  const item = items.find((item) => item?.path === path);

  if (item) {
    setPath({ tab: item.tab, item: item.title, subitem: null });

    setTabs({
      ...openedTabs,
      [item.tab]: true,
    });

    return;
  }

  const subitems = items.reduce((acc, item) => {
    if (item.items) {
      const tabItems = item.items.map((subitem) => ({
        ...subitem,
        tab: item.tab,
        itemName: item.title,
      }));

      return [...acc, ...tabItems];
    }

    return acc;
  }, [] as NavListPropsWithItemName[]);

  const subitem = subitems.find((subitem) => subitem?.path === path);

  if (subitem) {
    setPath({ tab: subitem.tab, item: subitem.itemName, subitem: subitem.title });

    setTabs({
      ...openedTabs,
      [subitem.tab]: true,
    });

    return;
  }

  /* Для /new /edit /{id} */
  const splitedPath = path.split('/');
  const absolutePath = `/${splitedPath[1]}/${splitedPath[2]}`;

  const absoluteTab = tabs.find((tab) => tab?.item?.path === absolutePath);

  if (absoluteTab) {
    setPath({ tab: absoluteTab.subheader, item: null, subitem: null });

    setTabs({
      ...openedTabs,
      [absoluteTab.subheader]: true,
    });

    return;
  }

  const absoluteItem = items.find((item) => item?.path === absolutePath);

  if (absoluteItem) {
    setPath({ tab: absoluteItem.tab, item: absoluteItem.title, subitem: null });

    setTabs({
      ...openedTabs,
      [absoluteItem.tab]: true,
    });

    return;
  }

  const absoluteSubitem = subitems.find((subitem) => subitem?.path === absolutePath);

  if (absoluteSubitem) {
    setPath({
      tab: absoluteSubitem.tab,
      item: absoluteSubitem.itemName,
      subitem: absoluteSubitem.title,
    });

    setTabs({
      ...openedTabs,
      [absoluteSubitem.tab]: true,
    });

    return;
  }

  setPath({
    tab: null,
    item: null,
    subitem: null,
  });
};
